<template>
	<div>
		<div class="x-stat">
			<a-row>
				<a-col :span="3">
					<a-statistic title="数量" :value="totalRow" />
				</a-col>
			</a-row>
		</div>

		<a-card :bordered="false">
			<div class="x-filter">
				<a-form layout="inline">
					<a-row :gutter="24">
						<a-col :span="4">
							<a-form-item label="关键词">
								<a-input v-model="queryParams.word" placeholder="关键词" />
							</a-form-item>
						</a-col>
						<a-col :span="4">
							<a-form-item label="类型">
								<a-select v-model="queryParams.type" allow-clear placeholder="请选择" style="width: 100%">
									<a-select-option v-for="o in violateTypeOptions" :key="o.value" :value="o.value">{{ o.label }}</a-select-option>
								</a-select>
							</a-form-item>
						</a-col>
						<template v-if="advanced">
							<a-col :md="8">
								<a-form-item label="创建时间">
									<a-range-picker @change="onCreateTime" v-model="createTime" style="width:100%" />
								</a-form-item>
							</a-col>
						</template>
						<a-col :span="!advanced && 4 || 24">
							<span class="x-filter-submit-box"
								:style="advanced && {float:'right', overflow:'hidden'} || {}">
								<a-button type="primary" @click="fetchTableData">查询</a-button>
								<a-button style="margin-left:8px" @click="rest()">重置</a-button>
								<a @click="toggleAdvanced" style="margin-left: 8px">
									{{ advanced ? '收起' : '展开' }}
									<a-icon :type="advanced ? 'up' : 'down'" />
								</a>
							</span>
						</a-col>
					</a-row>
				</a-form>
			</div>

			<div class="x-tool">
				<a-button type="primary" icon="plus" v-has="'/op/violateWordAdd'" @click="add">新增</a-button>
			</div>

			<a-table :rowKey="record => record.id" :columns="tableColumns" :loading="tableLoading"
				:dataSource="tableData" :pagination="false">
				
				<template slot="violateType" slot-scope="record">
					<p class="row">
						<span class="user-right-detail">{{ dictTrans('violateType', record.type) }}</span>
					</p>
				</template>

				<template slot="action" slot-scope="record">
					<a-popconfirm placement="topRight" title="你确定要删除本条记录?" @confirm="wordDel(record.id)">
						<a v-has="'/op/violateWordDel'" href="#">删除</a>
					</a-popconfirm>
					<a-divider type="vertical" />
					<a v-has="'/op/violateWordUpdate'" @click="update(record)">修改</a>
				</template>
			</a-table>

			<violate-word-form-modal ref="ViolateWordForm" :visible="ViolateWordFormVisible" :loading="ViolateWordFormLoading" :model="ViolateWordFormModel"
				@cancel="ViolateWordFormCancel" @ok="ViolateWordFormOk" />

			<div class="x-pagination">
				<a-pagination :pageSize="pageSize" v-model="pageIndex" :total="totalRow" @change="pageChange"
					:hideOnSinglePage="true" show-less-items />
			</div>
		</a-card>
	</div>
</template>

<script>
	import moment from "moment";
	import ViolateWordFormModal from "@/pages/op/violate_word/ViolateWordForm.vue";
	import {
		violateWordList,
		violateWordAdd,
		violateWordUpdate,
		violateWordDel
	} from "@/api/op/violateWord.js";
	import { dictTrans, dictList } from "@/utils/dictTrans.js";

	const VIOLATE_TYPE_OPTIONS = dictList('violateType');

	const tableColumns = [{
			title: '#',
			dataIndex: 'id'
		},
		{
			title: '关键词',
			dataIndex: 'word'
		},
		{
			title: '类型',
			scopedSlots: {
				customRender: 'violateType'
			}
		},
		{
			title: '创建时间',
			dataIndex: 'created'
		},
		{
			title: '操作',
			scopedSlots: {
				customRender: 'action'
			}
		}
	];

	export default {
		components: {
			ViolateWordFormModal
		},
		data() {
			return {
				advanced: false,
				queryParams: {},
				totalRow: 0,
				tableColumns,
				tableData: [],
				tableLoading: false,
				pageSize: 20,
				pageIndex: 1,
				ViolateWordFormVisible: false,
				ViolateWordFormLoading: false,
				ViolateWordFormModel: null,
				createTime: [],
				violateTypeOptions: VIOLATE_TYPE_OPTIONS,
			}
		},
		created() {
			this.fetchTableData();
		},
		methods: {
			dictTrans,
			fetchTableData() {
				this.tableLoading = true;
				this.queryParams.pageSize = this.pageSize;
				this.queryParams.page = this.pageIndex;
				violateWordList(this.queryParams).then(res => {
					this.totalRow = res.data.totalRow;
					this.tableData = res.data.recordList;

					this.tableLoading = false;
				});
			},
			pageChange(current) {
				this.pageIndex = current;
				this.fetchTableData();
			},
			toggleAdvanced() {
				this.advanced = !this.advanced;
			},
			onCreateTime(values) {
				this.queryParams.startCreateTime = moment(values[0]).unix();
				this.queryParams.endCreateTime = moment(values[1]).unix();
			},
			onActiveTime(values) {
				this.queryParams.startActiveTime = moment(values[0]).unix();
				this.queryParams.endActiveTime = moment(values[1]).unix();
			},
			add() {
				this.ViolateWordFormModel = null;
				this.ViolateWordFormVisible = true;
				this.$nextTick(() => {
					if (this.$refs.ViolateWordForm && this.$refs.ViolateWordForm.initForm) {
						this.$refs.ViolateWordForm.initForm();
					}
				});
			},
			update(record) {
				this.ViolateWordFormModel = {
					...record
				};
				this.ViolateWordFormVisible = true;
			},
			ViolateWordFormOk() {
				const wordForm = this.$refs.ViolateWordForm;
				if (!wordForm || !wordForm.$refs.adminForm) {
					return;
				}
				wordForm.$refs.adminForm.validate(valid => {
					if (!valid) {
						return;
					}
					const values = { ...wordForm.form };
					this.ViolateWordFormLoading = true;
					if (values.id > 0) {
						const payload = {
							id: values.id,
							type: values.type,
							word: (values.word || '').trim(),
						};
						violateWordUpdate(payload).then((res) => {
							if (res.isSucceed) {
								this.ViolateWordFormAfter('修改关键词成功');
							} else {
								this.ViolateWordFormLoading = false;
							}
						}).catch(() => {
							this.ViolateWordFormLoading = false;
						});
					} else {
						violateWordAdd(values).then((res) => {
							if (res.isSucceed == true && res.data.status == 'ok') {
								let msg = '新增关键词成功';
								if (res.data.repeatNum > 0) {
									msg += `,已过滤${res.data.repeatNum}个重复关键词`;
								}
								this.ViolateWordFormAfter(msg);
							} else {
								this.ViolateWordFormLoading = false;
							}
						}).catch(() => {
							this.ViolateWordFormLoading = false;
						});
					}
				});
			},
			ViolateWordFormCancel() {
				this.ViolateWordFormModel = null;
				this.ViolateWordFormVisible = false;
				if (this.$refs.ViolateWordForm && this.$refs.ViolateWordForm.initForm) {
					this.$refs.ViolateWordForm.initForm();
				}
			},
			ViolateWordFormAfter(message) {
				this.ViolateWordFormVisible = false;
				this.ViolateWordFormLoading = false;
				if (this.$refs.ViolateWordForm && this.$refs.ViolateWordForm.initForm) {
					this.$refs.ViolateWordForm.initForm();
				}
				this.fetchTableData();
				this.$message.success(message);
			},
			rest() {
				this.createTime = [];
				this.queryParams = {};
				this.pageIndex = 1;
				this.fetchTableData();
			},
			wordDel(id) {
				violateWordDel(id).then(() => {
					this.fetchTableData();
					this.ViolateWordFormAfter('删除关键词成功');
				});
			},
		}
	}
</script>

<style lang="less" scoped>
	
</style>
